import { DestroyRef, Injectable, Signal, signal } from '@angular/core';
import { PageBox } from '../types/service';

export interface BelegleserFieldSnapshot {
  path: string;
  label: string;
  value: string;
  required: boolean;
}

export interface BelegleserPositionSnapshot {
  path: string;
  number: string;
  description: string | null;
  net: string | null;
  uncertain: boolean;
}

export interface BelegleserSnapshot {
  fileName: string;
  documentType: string | null;
  readBy: 'template' | 'pipeline' | null;
  fields: BelegleserFieldSnapshot[];
  missingRequired: string[];
  positions: BelegleserPositionSnapshot[];
  selected: string[];
}

export interface BelegleserWordMatch {
  text: string;
  box: PageBox;
}

/** What the open review page offers the agent. */
export interface BelegleserAgentPort {
  readonly snapshot: Signal<BelegleserSnapshot>;
  highlight(path: string): boolean;
  suggestBox(path: string, box: PageBox): Promise<{ value: string } | null>;
  findText(text: string): BelegleserWordMatch[];
}

/**
 * Root-level handle on the route-scoped review state: the chat lives outside the
 * belegleser route, so its tools cannot inject the page's services. The page attaches
 * itself while it is open.
 */
@Injectable({ providedIn: 'root' })
export class BelegleserAgentBridge {
  readonly active = signal<BelegleserAgentPort | null>(null);

  attach(port: BelegleserAgentPort, destroyRef: DestroyRef): void {
    this.active.set(port);
    destroyRef.onDestroy(() => {
      if (this.active() === port) this.active.set(null);
    });
  }
}
